import { LogConsole } from './Mechanisms/LogToConsole';
import { LogToApi } from './Mechanisms/LogToApi';
import { Aux } from '../AuxillaryServices';
import { Log } from './Log';
// import { LogToIndexedDB } from './Mechanisms/LogToIndexedDb';

/**
 * @todo document this
 */
export function initializeLogger(): void {
    Log.Mechanism.push(new LogConsole());

    // Temporarily disable logging to IndexedDB
    //if (window.indexedDB) {
    //    Log.Mechanism.push(new LogToIndexedDB());
    //}

    Log.Mechanism.push(new LogToApi());

    Aux.AddListener(Log.onServiceDiscovered);
}
